// extracted by mini-css-extract-plugin
export default {"formControl":"Checkbox_formControl__edlxp","noLabel":"Checkbox_noLabel__5u6Uv"};